<template>
  <!-- 头部整体盒子 -->
  <div id="header" >
    <!-- 头部顶部 -->
<!--    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div>-->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/image/logo2.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <router-link to="/" tag="li">
            <div>
              <img src="@/assets/image/home.png">
            </div>
            <p>主页</p>
        </router-link>
        <router-link to="/productserve" tag="li">
          <div>
            <img src="@/assets/image/produce.png">
          </div>
          <p>产品与服务</p>
        </router-link>
        <router-link to="/studycenter" tag="li">
          <div>
            <img src="@/assets/image/study.png">
          </div>
          <p>研发中心</p>
        </router-link>
        <router-link to="/contactus" tag="li">
          <div>
            <img src="@/assets/image/contact.png">
          </div>
          <p>联系我们</p>
        </router-link>

<!--        <div class="language">
          <img class="languages" src="@/assets/image/language.png" />
          <img class="more" src="@/assets/image/down.png" />
        </div>-->
<!--        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>-->
      </ul>
      <div class="lange" @click="routeTo()">
        <div>
          <img src="@/assets/image/language.png">
        </div>
        <p>English</p>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">

      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">

        <div class="header-nav-m-logo">
          <img  class="center-block" src="@/assets/image/STlogo.png"  alt="logo">
        </div>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "产品和服务",
          path: "/productserve",
        },
        {
          name: "研发中心",
          path: "/studycenter",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        },
        {
          name: "English",
          path: "/homeENG",
          children: []
        },
        /*{
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "工作机会",
          path: "/jobchance",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }*/
      ]
    };
  },
  methods: {
    routeTo(){
      var routeName=this.$route.path;
      if(routeName=='/home'){
        this.$router.push('/homeENG')
      }
      if(routeName=='/studycenter'){
        this.$router.push('/studycenterENG')
      }
      if(routeName=='/contactus'){
        this.$router.push('/contactusENG')
      }
      if(routeName=='/productserve/suanxi'){
        this.$router.push('/productserveENG/suanxiENG')
      }
      if(routeName=='/productserve/lenzha'){
        this.$router.push('/productserveENG/lenzhaENG')
      }
      if(routeName=='/productserve/reduxin'){
        this.$router.push('/productserveENG/reduxinENG')
      }
      if(routeName=='/productserve/caitu'){
        this.$router.push('/productserveENG/caituENG')
      }
      if(routeName=='/productserve/gangguan'){
        this.$router.push('/productserveENG/gangguanENG')
      }
      if(routeName=='/productserve/jiagong'){
        this.$router.push('/productserveENG/jiagongENG')
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  font-family: 微软雅黑;
  background: rgba(22,38,62,0.7);
  /*transition: all ease 0.6s;*/
  width: 100%;
  position: fixed;
  z-index: 999;
}
#header .header-top {
  height: 80px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 80px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 190px;
  height: 42px;
  float: left;
  position: relative;
  margin-top: 18px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  height: 100%;

}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  color: white;
  /*line-height: 110px;*/
  float: right;
  margin: 0;
  max-width: 800px;
  padding-right: 50px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  height: 80px;
  float: left;
  margin: 0 15px;
  line-height: 80px;
  position: relative;
  display: flex;
  cursor: pointer;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/*#header .header-nav .header-nav-wrapper > li:hover p {
  color: #2D7DD9;
}*/
/*导航栏样式*/
#header .header-nav .header-nav-wrapper > li > div {
  width: 30px;
  height: 30px;
  background: white;
  margin-top: 25px;
  margin-right: 10px;
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  vertical-align: bottom;
}
#header .header-nav .header-nav-wrapper > li > div > img {
  width: 15px;
  height: 15px;
  margin: 7px auto;
}
#header .lange{
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 30px;
  display: flex;
  color: white;
}
#header .lange > div{
  width: 14px;
  height: 14px;
  margin-top: 3px;
  margin-right: 5px;
}
#header .lange > div img{
  width: 100%
}
#header .header-nav .language {
  margin-top: 33px;
  float: right;
  display: flex;
  width: 40px;
}
#header .header-nav .language .more{
  width: 11px;
  height: 7px;
  margin-top: 3px;
  margin-left: 3px;
}
#header .header-nav .language .languages{
  width: 15px;
  height: 15px;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
    background: #014594;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-menu img {
    width: 190px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  #header .header-nav .header-nav-wrapper > li {
    height: 80px;
    float: left;
    margin: 0 5px;
    line-height: 80px;
    position: relative;
    display: flex;
    cursor: pointer;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 80px;
    font-size: 20px;
    line-height: 50px;
    background: #014594;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background: #666;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #999;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue